import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShuffle } from "@fortawesome/free-solid-svg-icons";

export default function Main(props) {
  return (
    <div className="main">
      <h1 className="mainHeading">New Entry</h1>
      <button className="promptToggleBtn btn" onClick={props.promptToggle}>
        {props.promptState ? " Switch Prompt Off" : "Switch Prompt On"}
      </button>
      {props.promptState && (
        <div className="mainPrompt">
          <label htmlFor="mainInput" className="promptLabel">
            {props.prompt}
          </label>
          <button className="iconBtn" onClick={props.randomPrompt}>
            <FontAwesomeIcon icon={faShuffle} className="icon" />
          </button>
        </div>
      )}
      <textarea
        disabled={props.entrySaved ? true : false}
        type="text"
        placeholder={`Write anything and everything that is wandering in your mind right now. The aim is not to write good but just to write! Try to hit your daily goal of ${props.wordLim} words.`}
        className="mainInput"
        id="mainInput"
        onChange={props.handleChange}
        value={props.journalIn}
      ></textarea>
      <div className="mainButtons">
        {!props.entrySaved ? (
          <>
            <button
              className="btn lowBtn"
              onClick={(event) => props.handleClrClick(event)}
            >
              Clear
            </button>

            <button
              className="btn"
              onClick={() =>
                props.handleSaveClick(props.journalIn, props.wordsCount)
              }
            >
              Save Entry
            </button>
          </>
        ) : (
          <button className="btn" onClick={props.handleEditClick}>
            Edit Entry
          </button>
        )}
      </div>
    </div>
  );
}
